import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=4ab4872a&scoped=true&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=4ab4872a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4872a",
  null
  
)

export default component.exports